import {
  PG_ALAMAT,
  PG_DATA,
  PG_DEPARTEMEN,
  PG_DIVISI,
  PG_KELURAHAN,
  PG_MULAIKERJA,
  PG_NAMA,
  PG_NIK,
  PG_PENGEMBANGAN,
  PG_PERFORMA,
  PG_POSISI,
  PG_S1,
  PG_S2,
  PG_S3,
  PG_SMA,
  PG_SMP,
  PG_TANGGAL_LAHIR,
  PG_TEMPAT_LAHIR,
  PG_TINGKAT,
  PG_SELECTED,
  PG_TALENT,
} from "../../../constants";

const initialState = {};

export default function pegawaiReducer(state = initialState, action) {
  switch (action.type) {
    case "GET_DATA_TABLE_PEGAWAI":
      return {
        ...state,
        dataTable: action.data,
      };
    case PG_SELECTED:
      return action.data;
    case PG_ALAMAT:
      return { ...state, alamat: action.data };
    case PG_DATA:
      return { ...state, data: action.data };
    case PG_DEPARTEMEN:
      return { ...state, departemen: action.data };
    case PG_DIVISI:
      return { ...state, divisi: action.data };
    case PG_KELURAHAN:
      state = {
        ...state,
        kelurahanId: action.data,
      };
      return state;
    case PG_MULAIKERJA:
      return { ...state, mulaiKerja: action.data };
    case PG_NAMA:
      return { ...state, nama: action.data };
    case PG_NIK:
      return { ...state, nik: action.data };
    case PG_PENGEMBANGAN:
      return { ...state, pengembangan: action.data };
    case PG_PERFORMA:
      return { ...state, performa: action.data };
    case PG_POSISI:
      return { ...state, posisi: action.data };
    case PG_S1:
      return { ...state, s1: action.data };
    case PG_S2:
      return { ...state, s2: action.data };
    case PG_S3:
      return { ...state, s3: action.data };
    case PG_SMA:
      return { ...state, sma: action.data };
    case PG_SMP:
      return { ...state, smp: action.data };
    case PG_TALENT:
      return { ...state, bakat: action.data };
    case PG_TANGGAL_LAHIR:
      return { ...state, tanggalLahir: action.data };
    case PG_TEMPAT_LAHIR:
      return { ...state, tempatLahir: action.data };
    case PG_TINGKAT:
      return { ...state, tingkat: action.data };
    default:
      return state;
  }
}
